import { orgAPI } from "@/api/api";
import { useQuery } from "@tanstack/react-query";

export function useToolset(toolSetID: string | undefined) {
  return useQuery({
    queryKey: ["toolset", toolSetID],
    queryFn: () => orgAPI.toolSets.userShow(toolSetID!),
    enabled: !!toolSetID,
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
}
